import React, { useState } from "react"
import Title from "../components/title"
import Text from "../components/text"
import Imgix from "react-imgix"
import { Formik } from "formik"
import { signUp } from "../services/email"
import SEO from "../components/seo"

import styles from "../styles/scss/templates/techsandtradeprogram.module.scss"
import NewLayout from "../layout/newLayout"
import {
    TextInput,
    RadioGroup,
    ErrorSummary,
    FormStatus,
    SubmitButton,
    RequiredNote,
    bind,
    summaryErrors,
    phoneError,
    isValidEmail,
    formStyles as f,
} from "../components/form"

const TechAndTradeProgram = ({ pageContext: { page } }) => {
    const [showConfirmation, setShowConfirmation] = useState(false)

    return (
        <NewLayout>
            <SEO page={page} />
            <div
                className={
                    showConfirmation
                        ? styles.thankYouPageContainer
                        : styles.pageContainer
                }
                style={{
                    backgroundImage: `url(${page.heroImage.url})`
                }}
            >
                <div className={styles.heroContainer}>
                    <div className={styles.logoContainer}>
                        <a href="/techs-and-trades/">
                            <Imgix
                                src="/img/techsandtrade/ttlogo.svg"
                                htmlAttributes={{ alt: "WD-40 Techs & Trade Logo" }}
                            />
                        </a>
                    </div>
                </div>
                {showConfirmation ? (
                    <ConfirmationSection />
                ) : (
                    <SignupFormSection setShowConfirmation={setShowConfirmation} />
                )}
            </div>
        </NewLayout>
    )
}

const ConfirmationSection = () => (
    <div className={styles.confirmWhiteSection}>
        <div
            className={
                styles.confirmWhiteSection__confirmContentWrapper
            }
        >
            <Title
                className={
                    styles.confirmWhiteSection__contentWrapper__confirmTitle
                }
                value={"THANK YOU!"}
            />
            <br />
            <Text
                className={
                    styles.confirmWhiteSection__contentWrapper__bodyText
                }
            >
                Your information has been submitted. Thanks! A
                confirmation email is on its way to your email
                address and should arrive shortly.
            </Text>
            <br />
            <Text
                className={
                    styles.confirmWhiteSection__contentWrapper__bodyText
                }
            >
                Note: To ensure proper delivery of our emails,
                take a moment now and add us,{" "}
                <Text
                    className={
                        styles.confirmWhiteSection__contentWrapper__bodyText__anchor
                    }
                >
                    no-reply@wd40company.com
                </Text>
                , to your address book, trusted sender list, or
                company white list.
            </Text>
            <a
                href="/techs-and-trades/"
                className={
                    styles.confirmWhiteSection__contentWrapper__anchor
                }
            >
                <i class="fa fa-chevron-left"></i> Back to the page
            </a>
        </div>
    </div>
)


const INDUSTRIES = [
    "Automotive and Transportation",
    "Construction and Skilled Trades",
    "Industrial",
    "Agricultural",
]
const INDUSTRY_TIMES = ["0 - 5 Years", "6 - 10 Years", "11 - 15 Years", "16 - 20 Years", "20+ Years"]

const SignupFormSection = ({ setShowConfirmation }) => {
    const [submitError, setSubmitError] = useState(false)
    return (
        <div className={styles.whiteSection}>
            <div className={styles.whiteSection__contentWrapper}>
                <Title
                    className={styles.whiteSection__contentWrapper__title}
                    value={"Join the techs and trades program"}
                />
                <Formik
                    initialValues={{
                        firstName: "",
                        lastName: "",
                        email: "",
                        phone: "",
                        industry: "",
                        industrytime: "",
                        userplus18yearsold: "",
                    }}
                    validate={values => {
                        var errors = []
                        if (values.firstName === "") {
                            errors.push({ field: "firstName", message: "First Name is required" })
                        }
                        if (values.lastName === "") {
                            errors.push({ field: "lastName", message: "Last Name is required" })
                        }
                        if (values.email === "") {
                            errors.push({ field: "email", message: "Email is required" })
                        } else if (!isValidEmail(values.email)) {
                            errors.push({ field: "email", message: "Invalid email address" })
                        }
                        const phoneMsg = phoneError(values.phone, { required: true, requiredMessage: "Mobile Phone Number is required" })
                        if (phoneMsg) errors.push({ field: "phone", message: phoneMsg })
                        if (values.industry === "") {
                            errors.push({ field: "industry", message: "Please select an industry" })
                        }
                        if (values.industrytime === "") {
                            errors.push({ field: "industrytime", message: "Please select how long have you been in the industry" })
                        }
                        if (values.userplus18yearsold === "") {
                            errors.push({ field: "userplus18yearsold", message: "Please select if you are over 18 years old" })
                        }
                        return errors
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitError(false)
                        const optSubject =
                            "Confirming your Subscription to the Techs and Trades Email List"
                        const optMessage = `Thanks for joining the Techs and Trades newsletter! Expect some epic industry content, product tips, special offers and more coming your way every month.\n \nTo confirm your subscription, please click this link or paste it into your browser:\n \n[opt_in_url] \n \nTo ensure proper delivery of our future emails, take a moment now and add our email address - [rsvp_email] - to your address book, trusted sender list, or company white list. \n \nif you'd like to update your email preferences, use this link:\n \n[opt_in_url] \n \nIf you do not wish to receive our emails, or this email has reached you in error, please click or copy and paste this link in your browser window to remove yourself from our list:\n \n[opt_out_url] \n \nThanks, and welcome!\n[rsvp_name]\n`

                        const data = {
                            firstName: values.firstName,
                            lastName: values.lastName,
                            email: values.email,
                            phone: values.phone,
                            lists: [26126285], // 26126285 --> Techs and Trades Program Group ID from Emma Service
                            industry: values.industry,
                            industrytime: values.industrytime,
                            birthday: undefined,
                            userplus18yearsold: values.userplus18yearsold,
                            confirmation: true,
                            optSubject,
                            optMessage,
                            signupFormID: 1930094,
                            formIdentifier: "techstrades",
                        }
                        signUp(data)
                            .then(() => {
                                setSubmitting(false)
                                setShowConfirmation(true)
                            })
                            .catch(err => {
                                console.log(err)
                                setSubmitting(false)
                                setSubmitError(true)
                            })
                    }}
                >
                    {props => (
                        <form className={f.form} onSubmit={props.handleSubmit} noValidate>
                            <RequiredNote />
                            <ErrorSummary errors={summaryErrors(props)} submitCount={props.submitCount} />
                            <FormStatus status={submitError ? "error" : null} />
                            <div className={f.row}>
                                <TextInput label="First Name" required autoComplete="given-name" {...bind(props, "firstName")} />
                                <TextInput label="Last Name" required autoComplete="family-name" {...bind(props, "lastName")} />
                            </div>
                            <div className={f.row}>
                                <TextInput label="Email" type="email" required autoComplete="email" {...bind(props, "email")} />
                                <TextInput label="Phone Number" type="tel" mask="phone" required autoComplete="tel-national" placeholder="(000) 000-0000" {...bind(props, "phone")} />
                            </div>
                            <RadioGroup
                                legend="Which industry focus describes you?"
                                required
                                options={INDUSTRIES}
                                {...bind(props, "industry")}
                            />
                            <RadioGroup
                                legend="How long have you been in the industry?"
                                required
                                options={INDUSTRY_TIMES}
                                {...bind(props, "industrytime")}
                            />
                            <RadioGroup
                                legend="Are you 18 years or older?"
                                required
                                row
                                options={[{ value: "yes", text: "Yes" }, { value: "no", text: "No" }]}
                                {...bind(props, "userplus18yearsold")}
                            />
                            <div className={f.actions}>
                                <SubmitButton busy={props.isSubmitting}>Join the Techs and Trades Program</SubmitButton>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default TechAndTradeProgram
